class SwiperDialogVideo extends HTMLElement {
    constructor() {
        super();
        this.swiper = null;
        this.swiperContainer = this.querySelector('.swiper-dialog-video__swiper-container .swiper');
        this.swiperSlide = this.swiperContainer.querySelectorAll('.swiper-slide');
        this.dialogContainer = this.querySelector('.swiper-dialog-video__dialog');
        this.dialogCloseButton = this.querySelector('.swiper-dialog-video__dialog-close-mark');
        // this.dialogContentContainer = this.querySelector('.swiper-dialog-video__dialog-info');
        this.mediaContainer = this.querySelector('.swiper-dialog-video__dialog-inner');
        this.mediaElements = this.mediaContainer.querySelector('.swiper-dialog-video__dialog-video');
        this.swiperThumb = null;
        this.swiperThumbContainer = this.querySelector('.swiper-dialog-video__thumb .swiper');
    }

    connectedCallback() {
        this.initThumbSwiper();
        this.initSwiper();
        this.swiperSlide.forEach(slide => {
            slide.addEventListener('click', () => this.slideClick(slide));
        });
        this.dialogCloseButton.addEventListener('click', () => this.dialogHide());
    }

    initThumbSwiper() {
        const pagination = this.swiperThumbContainer.querySelector('.swiper-pagination');
        this.swiperThumb = new Swiper(this.swiperThumbContainer, {
            slidesPerView: 3,
            spaceBetween: 15,
            watchSlidesVisibility: true,
            autoHeight: true,
            pagination: {
                el: pagination || null,
                clickable: true,
            },
        })
    }

    initSwiper() {
        const prevButton = this.querySelector('.swiper-button-prev');
        const nextButton = this.querySelector('.swiper-button-next');
        const pagination = this.swiperContainer.querySelector('.swiper-pagination');
        this.swiper = new Swiper(this.swiperContainer, {
            slidesPerView: 3,
            spaceBetween: 40,
            autoHeight: true,
            navigation: {
                nextEl: nextButton || null,
                prevEl: prevButton || null,
            },
            pagination: {
                el: pagination || null,
                clickable: true,
            },
            thumbs: {
                swiper: this.swiperThumb,
            },
            breakpoints: {
                320: {
                    spaceBetween: 25,
                    slidesPerView: 1,
                },
                750: {
                    spaceBetween: 25,
                    slidesPerView: 2,
                },
                1100: {
                    spaceBetween: 40,
                    slidesPerView: 3,
                }
            }
        });
    }

    slideClick(slide) {
        this.dialogShow();
        // this.copyInfo(slide);
        const src = slide.getAttribute('data-src');
        const title = slide.getAttribute('data-title');
        const poster = slide.getAttribute('data-full-poster');
        this.loadMedia(src, title, poster);
    }

    dialogShow() {
        this.dialogContainer.setAttribute('open', '');
    }

    copyInfo(slide) {
        const infoContainer = slide.querySelector('.swiper-dialog-video__info');
        this.dialogContentContainer.innerHTML = infoContainer.innerHTML;
    }

    dialogHide() {
        this.dialogContainer.removeAttribute('open');
        if (this.mediaElements) {
            this.mediaElements.innerHTML = '';
            this.mediaElements.style.removeProperty('--video-aspect-ratio');
            this.mediaContainer.classList.remove('swiper-dialog-video__dialog-video--portrait');
            this.mediaContainer.classList.remove('swiper-dialog-video__dialog-video--landscape');
        }
    }

    async loadMedia(src, title, poster) {
        if (!this.mediaElements) {
            console.warn('Media container not found');
            return;
        }

        try {
            // 动态导入 Vidstack
            const { VidstackPlayer, VidstackPlayerLayout } = await import('https://cdn.vidstack.io/player@1.11.30');

            // 创建布局
            const layout = new VidstackPlayerLayout({
                thumbnails: null,
            });

            // 清空旧内容
            this.mediaElements.innerHTML = '';

            // 创建播放器
            const player = await VidstackPlayer.create({
                target: this.mediaElements,
                src: src || null,
                viewType: 'video',
                streamType: 'on-demand',
                logLevel: 'warn',
                muted: true,
                crossOrigin: true,
                playsInline: true,
                poster: poster || null,
                autoplay: true,
                layout
            });

            // 获取 video 元素
            const videoEl = this.mediaElements.querySelector('video');
            if (videoEl) {
                videoEl.addEventListener('loadedmetadata', () => {
                    const { videoWidth, videoHeight } = videoEl;
                    if (videoWidth && videoHeight) {
                        const ratioValue = `${videoWidth}/${videoHeight}`;
                        this.mediaElements.style.setProperty('--video-aspect-ratio', ratioValue);

                        if (videoWidth > videoHeight) {
                            this.mediaContainer.classList.remove('swiper-dialog-video__dialog-video--portrait');
                            this.mediaContainer.classList.add('swiper-dialog-video__dialog-video--landscape');
                        } else {
                            this.mediaContainer.classList.remove('swiper-dialog-video__dialog-video--landscape');
                            this.mediaContainer.classList.add('swiper-dialog-video__dialog-video--portrait');
                        }
                    }
                });
            } else {
                console.warn('Video element not found inside Vidstack player');
            }

        } catch (error) {
            console.error('Failed to load VidstackPlayer:', error);
        }
    }

    disconnectedCallback() {
        this.swiperSlide.forEach(slide => {
            slide.removeEventListener('click', () => this.slideClick(slide));
        });
        this.dialogCloseButton.removeEventListener('click', () => this.dialogHide());
    }
}

customElements.define('swiper-dialog-video', SwiperDialogVideo);